import useContentful from '../api/useContentful';

export default function useWealth() {
    const { data, isLoading } = useContentful('6FFh2B4vZYFuVbARP4YGCX');
    const sections  = data?.sections || [];
    
    return {
        sections,
        isLoading
    };
}
